import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sliderStatus: localStorage.getItem('sliderStatus') || false,
    lang: localStorage.getItem('lang') || 'en'
  },
  mutations: {
    getSliderStatus(state, sliderStatus) {
      state.sliderStatus = sliderStatus
      localStorage.setItem('sliderStatus', sliderStatus)
    },
    switchLang(state, lang) {
      state.lang = lang
      window.app.$i18n.locale = lang
      localStorage.setItem('lang', lang)
    }
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/store.js